import Image from './Image';
export * from './Image';
export default Image;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-image/es/index.js
// module id = 459
// module chunks = 0